import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {environment} from '@environments/environment';

@Component({
  selector: 'app-mailer-dns-info-modal',
  templateUrl: './mailer-dns-info-modal.component.html',
  styleUrls: ['./mailer-dns-info-modal.component.css'],
})
export class MailerDnsInfoModalComponent implements OnInit {
  @Input() public domain: string = '';
  @Input() public tokens: string = '';
  @Input() public serviceProvider: string = '';
  @Input() public campaignCode: string = '';
  shareWidgetLinkUrl = '';

  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {
    this.shareWidgetLinkUrl = environment.frontUrl.replace('/#', '') + `/b/campaign/${this.campaignCode}/domain_verify_instruction`;
  }

  close() {
    this.modal.dismiss('cancel');
  }

  getDomain(identity: string) {
    //
    // Get domain from email
    const splitEmail = identity.split('@');
    const domain = splitEmail[1];

    return domain;
  }
}
